import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

//

@Component({
  selector: 'svg-outlet', // eslint-disable-line @angular-eslint/component-selector
  template: `<div #svgOutlet></div>`,
})
export class SvgOutletComponent implements OnInit {
  @ViewChild('svgOutlet', { static: true }) svgOutlet :ElementRef;

  constructor() {}

  ngOnInit() {
    this.svgOutlet.nativeElement.innerHTML = window.__fasvg + window.__lumsvg;
  }
}
